import axios from "axios";

/**
 * 通用埋点函数
 * @param {string} userId - 用户ID
 * @param {string} funCode - 功能编码
 * @param {string} funName - 功能名称
 */
export const trackRecord = async (userId, funCode, funName) => {
  try {
    await axios.post(`${window.PUBLIC_URL}/medagent/robot/funRecord`, {
      userId,
      funCode,
      funName,
    });
    console.log(`>>> [埋点成功] ${funName} (${funCode})`);
  } catch (err) {
    console.error(">>> [埋点失败]:", err);
  }
};
